import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";

export default function Erp() {
  return (
    <div className="Erp pt-[160px] sm:pt-0">
      <Helmet>
        <title>Top ERP Services for Businesses in Dubai | Mean3</title>
        <meta
        name="description"
        content="Mean3 provides ERP services designed for your business needs in Dubai. Boost efficiency, manage resources, and drive growth. Contact us today!"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
    </div>
  );
}
